import { render, staticRenderFns } from "./HotQuestCard.vue?vue&type=template&id=0c99773d&scoped=true&"
import script from "./HotQuestCard.vue?vue&type=script&lang=js&"
export * from "./HotQuestCard.vue?vue&type=script&lang=js&"
import style0 from "./HotQuestCard.vue?vue&type=style&index=0&id=0c99773d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c99773d",
  null
  
)

export default component.exports